import { useState } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import { BMD_COPY, BMD_RULES } from "../constants/bmd.constants"

export function BmdRulesCard() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Card className="mb-2 shadow-sm border-0">
      <CardBody style={{ padding: "10px 16px" }}>
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ cursor: "pointer" }}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <h6 className="font-size-13 fw-700 text-dark mb-0">
            {BMD_COPY.RULES_HEADING}
          </h6>
          <i
            className={`mdi ${
              isOpen ? "mdi-chevron-up" : "mdi-chevron-down"
            } font-size-16 text-muted`}
          ></i>
        </div>
        <Collapse isOpen={isOpen}>
          <ul className="mb-0 ps-3 mt-2">
            {BMD_RULES.map((rule) => (
              <li key={rule} className="mb-1 font-size-12 text-muted">
                {rule}
              </li>
            ))}
          </ul>
        </Collapse>
      </CardBody>
    </Card>
  )
}

export default BmdRulesCard
